;(function() {

	function reloadErrors(form, errors) {
		// console.log(errors);
		// Clear errors
		var inputs = form.querySelectorAll(".is-invalid");
		for (var i = 0; i < inputs.length; ++i) {
			var input = inputs[i];
			input.classList.remove("is-invalid");
		}

		var feedbacks = form.querySelectorAll(".invalid-feedback");
		for (var i = 0; i < feedbacks.length; ++i) {
			var feedback = feedbacks[i];
			feedback.remove();
		}

		var feedbacksList = form.querySelector(".feedbacks-list");
		if (feedbacksList) {
			feedbacksList.classList.add("d-none");
			feedbacksList.querySelector("ul").innerHTML = "";
		}

		var feedbacksCount = form.querySelector(".feedbacks-count");
		if (feedbacksCount) {
			feedbacksCount.classList.add("d-none");
		}


		// Put new errors
		var modelName = form.getAttribute("data-model-name");

		var errorsCount = 0;
		for (var key in errors) {
			errorsCount += 1;

			var errorMessage = errors[key];
			var fieldName = modelName + "[" + key + "]";

			var input = form.querySelector("[name='" + fieldName + "'], [data-field-name='" + fieldName + "']");
			if (input) {
				input.classList.add("is-invalid");
				var formGroup = input.closest(".form-group");
				if (formGroup) {
					var feedback = document.createElement("small");
					feedback.classList.add("form-text", "invalid-feedback");
					feedback.innerHTML = errorMessage.message;
					formGroup.append(feedback);
				}
			}
		}

		// Create list of errors
		if (feedbacksList && errorsCount) {
			var list = feedbacksList.querySelector("ul");

			for (var key in errors) {
				var error = errors[key];
				var item = document.createElement("li");
				item.innerHTML = error.title + " &mdash; " + error.message;

				list.append(item);
			}

			feedbacksList.classList.remove("d-none");
		}

		if (feedbacksCount && errorsCount) {
			feedbacksCount.classList.remove("d-none");
			feedbacksCount.querySelector(".count").innerHTML = errorsCount;
		}
	}

	function onAjaxResponse(kind, status, event, callback, form) {
		form.classList.remove("sending-request");
		if (kind == "error") {
			form.classList.add("request-error");
		}

		var responseJSON = null;
		try {
			responseJSON = JSON.parse(event.target.response);
		} catch (exception) {
		}

		reloadErrors(form, responseJSON.errors);
	}

	function getCsrfToken() {
		return document.head.querySelector("meta[name='csrf-token']").getAttribute("content");
	}

	document.addEventSelectorListener("input", "form[data-autosave]", function(event, target) {
		target.classList.remove("request-error");
		target.classList.add("sending-request");

		var url = target.getAttribute("action");
		var inputs = target.querySelectorAll("input[type='text'], input[type='checkbox'], input[type='number'], input[type='tel'], input[type='email'], input[type='radio'], input[type='hidden'], select, textarea");
		var formData = new FormData(target);

		// for (var i = 0; i < inputs.length; ++i) {
		// 	var input = inputs[i];
		// 	var name = input.getAttribute("name");
		// 	var value = input.value;

		// 	console.log(name, value);
		// 	formData.append(name, value);
		// }

		var fileInputs = target.querySelectorAll("input[type='file']");
		for (var i = 0; i < fileInputs.length; ++i) {
			var fileInput = fileInputs[i];
			var name = fileInput.getAttribute("name");
		// 	var value = input.value;

		// 	console.log(name, value);
			formData.delete(name);
		}


		var xhr = new XMLHttpRequest();

		xhr.addEventListener("load", function(event) {
			onAjaxResponse("success", xhr.status, event, null, target);
		});
		xhr.addEventListener("error", function(event) {
			onAjaxResponse("error", xhr.status, event, null, target);
		});

		xhr.open("POST", url);
		xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
		// xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
		xhr.setRequestHeader("X-CSRF-Token", getCsrfToken());

		xhr.send(formData);

	});

	// *************************************************************************
	// Class
	// *************************************************************************

	// function Autosave(form) {
	// 	this.form = form;
	// }
	// Autosave.prototype = {
	// 	constructor: Autosave,


	// };


	// *************************************************************************
	// Bind
	// *************************************************************************

	// story.onDocumentReady(function() {
	// 	var forms = document.querySelectorAll("form[data-autosave]");
	// 	for (var i = 0; i < forms.length; ++i) {
	// 		var form = forms[i];
	// 		new Autosave(form);
	// 	}
	// });

}());